import { IconDeviceLaptop } from "@tabler/icons-react"
import ScalerLogo from "public/images/Scaler-logo.svg"
import SSBCompactLogo from "public/images/ssbLogoDark.svg"
import SSTCompactLogo from "public/images/sstLogo.svg"
import IMSLogo from "public/images/webp/ims-logo.webp"
import SSBLogo from "public/images/webp/ssb-logo.webp"
import TimeLogo from "public/images/webp/time-logo.webp"
import { InterviewConfig } from "types/interview"

export const SESSION_STATUS = {
  invited: "invited",
  ongoing: "ongoing",
  not_started: "not_started",
  not_found: "not_found",
  expired: "expired",
  completed: "completed",
} as const

export const SESSION_TYPE = {
  Conversation: "Conversation",
  TestSession: "TestSession",
  TestGroupSession: "TestGroupSession",
} as const

export type SessionType = (typeof SESSION_TYPE)[keyof typeof SESSION_TYPE]

export type SessionStatus = (typeof SESSION_STATUS)[keyof typeof SESSION_STATUS]

export const BROKER_INFO_INTEREST_MODAL_PARAM = "show-broker-info-interest-modal"

export const UNAUTHORIZED_STATUS: SessionStatus[] = [SESSION_STATUS.not_found, SESSION_STATUS.expired]

export const getInterviewSlug = (type: string) => {
  return type.replaceAll("-", "_")
}

export const INTERVIEW_CONFIG: Record<string, InterviewConfig> = {
  "angular-proctored-e0750c": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "angular_proctored_e0750c",
    title: "Angular Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "angular-non-proctored-843c75": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "angular_non_proctored_843c75",
    title: "Angular Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "django-proctored-bf30ef": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "django_proctored_bf30ef",
    title: "Django Mock Interview",
    emotionsEnabled: false,
    dualCameraRequired: true,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: true,
  },
  "django-non-proctored-1e18ab": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "django_non_proctored_1e18ab",
    title: "Django Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: true,
  },
  "dsa-proctored-2e0b2b": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "dsa_proctored_2e0b2b",
    title: "DSA Mock Interview",
    emotionsEnabled: false,
    dualCameraRequired: true,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "dsa-non-proctored-647a92": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "dsa_non_proctored_647a92",
    title: "DSA Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "eda-proctored-3a5d81": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "eda_proctored_3a5d81",
    title: "EDA Mock Interview",
    emotionsEnabled: false,
    dualCameraRequired: true,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "eda-non-proctored-88276e": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "eda_non_proctored_88276e",
    title: "EDA Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "mern-proctored-f371c2": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "mern_proctored_f371c2",
    title: "MERN Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: true,
  },
  "mern-non-proctored-9bc22a": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "mern_non_proctored_9bc22a",
    title: "MERN Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: true,
  },
  "react-proctored-5c4941": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "react_proctored_5c4941",
    title: "React Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: true,
  },
  "react-non-proctored-e33df": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "react_non_proctored_e33df",
    title: "React Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: true,
  },
  "devops-dsa-proctored-6046fd": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "devops_dsa_proctored_6046fd",
    title: "DevOps DSA Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "devops-dsa-non-proctored-efd4b3": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "devops_dsa_non_proctored_efd4b3",
    title: "DevOps DSA Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "devops-linux-cs-fundamentals-proctored-b78112": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "devops_linux_cs_fundamentals_proctored_b78112",
    title: "DevOps Linux CS Fundamentals Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "devops-linux-cs-fundamentals-non-proctored-6b0c4b": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "devops_linux_cs_fundamentals_non_proctored_6b0c4b",
    title: "DevOps Linux CS Fundamentals Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "computer-vision-proctored-e001b5": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "computer_vision_proctored_e001b5",
    title: "Computer Vision Mock Interview",
    emotionsEnabled: false,
    dualCameraRequired: true,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: true,
  },
  "computer-vision-non-proctored-68931d": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "computer_vision_non_proctored_68931d",
    title: "Computer Vision Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: true,
  },
  "nlp-proctored-f8c65a": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "nlp_proctored_f8c65a",
    title: "NLP Mock Interview",
    emotionsEnabled: false,
    dualCameraRequired: true,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: true,
  },
  "nlp-non-proctored-95fff0": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "nlp_non_proctored_95fff0",
    title: "NLP Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: true,
  },
  "supervised-learning-proctored-d351ee": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "supervised_learning_proctored_d351ee",
    title: "Supervised Learning Mock Interview",
    emotionsEnabled: false,
    dualCameraRequired: true,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "supervised-learning-non-proctored-44ac8a": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "supervised_learning_non_proctored_44ac8a",
    title: "Supervised Learning Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "unsupervised-learning-proctored-b90ca4": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "unsupervised_learning_proctored_b90ca4",
    title: "Unsupervised Learning Mock Interview",
    emotionsEnabled: false,
    dualCameraRequired: true,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "unsupervised-learning-non-proctored-abf257": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "unsupervised_learning_non_proctored_abf257",
    title: "Unsupervised Learning Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "resume-discussion-proctored-1f239": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "resume_discussion_proctored_1f239",
    dualCameraRequired: true,
    formRequired: true,
    title: "Resume Discussion Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "language-java-proctored-9a4cc0": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "language_java_proctored_9a4cc0",
    title: "Java Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "language-java-non-proctored-88488d": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "language_java_non_proctored_88488d",
    title: "Java Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "language-js-proctored-d7034d": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "language_js_proctored_d7034d",
    title: "JavaScript Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "language-js-non-proctored-35ae98": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "language_js_non_proctored_35ae98",
    title: "JavaScript Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "language-python-proctored-c8bd3a": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "language_python_proctored_c8bd3a",
    title: "Python Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "language-python-non-proctored-78a462": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "language_python_non_proctored_78a462",
    title: "Python Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "springboot-proctored-b4cef6": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "springboot_proctored_b4cef6",
    title: "Spring Boot Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "springboot-non-proctored-7c805": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "springboot_non_proctored_7c805",
    title: "Spring Boot Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "resume-builder-work-experience-projects-buqxwb": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "resume_builder_work_experience_projects_buqxwb",
    title: "Resume Builder: Work Experience and Projects Helper",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "resume-discussion-non-proctored-7248f9": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "resume_discussion_non_proctored_7248f9",
    title: "Resume Discussion Mock Interview",
    formRequired: true,
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "demo-itc-marketing-interview-havImi": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "demo_itc_marketing_interview_havImi",
    title: "Demo: ITC Marketing Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "demo-itc-manufacturing-interview-hdubec": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "demo_itc_manufacturing_interview_hdubec",
    title: "Demo: ITC Manufacturing Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "scaler-sales-recruitment-interview-xioena": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "scaler_sales_recruitment_interview_xioena",
    title: "Scaler Sales Recruitment Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "ims-ai-personal-interview-powered-by-ssb": {
    theme: "dark",
    variant: "green",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "ims_ai_personal_interview_powered_by_ssb",
    title: "AI Personal Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: IMSLogo,
      name: "Institute of Management Studies",
    },
    broker: {
      logo: SSBLogo,
      showInfoInterestModal: true,
      name: "Scaler School of Business",
      infoInterestFormId: "z4PlPAaZ",
      url: "https://www.scaler.com/school-of-business/?utm_source=part&utm_medium=p001&utm_campaign=ai-tl-fbpg",
    },
    streamingMicrophone: false,
  },
  "behavioral-practice-interview-8dlg9z": {
    theme: "dark",
    variant: "green",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "behavioral_practice_interview_8dlg9z",
    title: "Behavioral Practice Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: SSBCompactLogo,
      name: "Scaler School of Business",
    },
    streamingMicrophone: false,
  },
  dsa: {
    theme: "dark",
    variant: "blue",
    proctoring: "full_proctored",
    sessionType: "TestSession",
    assistant: "dsa",
    title: "DSA Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "resume-discussion": {
    theme: "dark",
    variant: "blue",
    proctoring: "non_proctored",
    sessionType: "TestSession",
    assistant: "resume_discussion",
    title: "Resume Discussion Interview",
    formRequired: true,
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  mern: {
    theme: "dark",
    variant: "blue",
    proctoring: "full_proctored",
    sessionType: "TestSession",
    assistant: "mern",
    title: "MERN Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "ssb-screening-round": {
    theme: "dark",
    variant: "green",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "ssb_screening_round",
    title: "Scaler School of Business - Screening Round",
    emotionsEnabled: true,
    showImmediateFeedback: false,
    brand: {
      logo: SSBCompactLogo,
      name: "Scaler School of Business",
    },
    streamingMicrophone: false,
  },
  "sst-screening-round": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    dualCameraRequired: true,
    assistant: "sst_screening_round",
    title: "Scaler School of Technology - Screening Round",
    emotionsEnabled: true,
    showImmediateFeedback: false,
    brand: {
      logo: SSTCompactLogo,
      name: "Scaler School of Technology",
    },
    streamingMicrophone: false,
  },
  "scaler-aiml-entrance-test-kjzuj": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "scaler_aiml_entrance_test_kjzuj",
    title: "Scaler AI ML Entrance Test",
    emotionsEnabled: false,
    showImmediateFeedback: false,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "time-ai-mba-personal-interview-gwxqni": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "time_ai_mba_personal_interview_gwxqni",
    title: "T.I.M.E. AI MBA Personal Interview",
    formRequired: true,
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: TimeLogo,
      name: "T.I.M.E.",
    },
    streamingMicrophone: false,
  },
  "scaler-product-analyst-intern-hiring-gwxqni": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "scaler_product_analyst_intern_hiring_gwxqni",
    title: "Scaler Product Analyst Interview",
    emotionsEnabled: false,
    showImmediateFeedback: false,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "dsa-dual-camera": {
    theme: "dark",
    variant: "blue",
    proctoring: "full_proctored",
    sessionType: "TestSession",
    assistant: "dsa",
    dualCameraRequired: true,
    title: "DSA Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "demo-amritesh": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "demo_amritesh",
    title: "Demo Amritesh Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: true,
  },
  "demo-aashna": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "demo_aashna",
    title: "Demo Aashna Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: true,
  },
  "demo-aashna-v1": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "demo_aashna_v1",
    title: "Demo Aashna V1 Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: true,
  },
  "demo-swayam": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "demo_swayam",
    title: "Demo Swayam Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: true,
  },
  "demo-swayam-2": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "demo_swayam_2",
    title: "Demo Swayam 2 Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: true,
  },
  "sst-dsa-test-19march-vo92eu": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "sst_dsa_test_19march_vo92eu",
    title: "SST DSA Test 19 March",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "demo-debashis": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "demo_debashis",
    title: "Demo Debashis Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: true,
  },
  "demo-kanishk": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "demo_kanishk",
    title: "Demo Kanishk Mock Interview",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: true,
  },
  "analysis-of-income-statement": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "analysis_of_income_statement",
    title: "Analysis of Income Statement",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "finding-effective-tax-rate": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "finding_effective_tax_rate",
    title: "Finding Effective Tax Rate",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "calculate-income-tax": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "calculate_income_tax",
    title: "Calculate Income Tax",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "find-carrying-amount": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "find_carrying_amount",
    title: "Find Carrying Amount",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "talk-to-teaching-assistant": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "talk_to_teaching_assistant",
    title: "Talk to Teaching Assistant",
    emotionsEnabled: false,
    showImmediateFeedback: false,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "assignment-question-delayed-function-fullstack-development": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "assignment_question_delayed_function_fullstack_development",
    title: "Assignment Question: (Delayed Function) - FullStack Development",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "assignment-question-periodic-printer-fullstack-development": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "non_proctored",
    assistant: "assignment_question_periodic_printer_fullstack_development",
    title: "Assignment Question: (Periodic Printer) - FullStack Development",
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "zura-ventures-dsa-interview-bsxiba": {
    theme: "dark",
    variant: "blue",
    sessionType: "TestSession",
    proctoring: "full_proctored",
    assistant: "zura_ventures_dsa_interview_bsxiba",
    title: "Zura Ventures DSA Interview",
    emotionsEnabled: false,
    showImmediateFeedback: false,
    dualCameraRequired: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "resume-consultation": {
    theme: "dark",
    variant: "blue",
    proctoring: "non_proctored",
    sessionType: "TestSession",
    assistant: "resume_consultation",
    title: "Resume Consultation Interview",
    formRequired: true,
    emotionsEnabled: false,
    showImmediateFeedback: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
  "analytics-sql-assessment-round-hdbwua": {
    theme: "dark",
    variant: "blue",
    proctoring: "full_proctored",
    sessionType: "TestSession",
    assistant: "analytics_sql_assessment_round_hdbwua",
    title: "Analytics SQL Assessment Round",
    formRequired: false,
    emotionsEnabled: false,
    showImmediateFeedback: false,
    dualCameraRequired: true,
    brand: {
      logo: ScalerLogo,
      name: "Scaler",
    },
    streamingMicrophone: false,
  },
}

export const INTERVIEW_MODE = {
  non_proctored: "non_proctored",
  full_proctored: "full_proctored",
} as const

export const WAITING_LOBBY_STAGE_CONFIG = {
  TEST_DETAILS_FORM: 0,
  ANALYZING_PROJECT: 1,
  TEST_INSTRUCTIONS: 2,
} as const

export const SYSTEM_CHECK_PARAMS = {
  PROCTORING_MODE: "proctoring_mode",
  DUAL_CAMERA_REQUIRED: "dual_camera_required",
} as const

export const ONBOARDING_SECTION_CONFIG = [
  {
    Icon: IconDeviceLaptop,
    href: "/interview/system-check",
    title: "Check System Compatibility",
    description: "Make sure your device meets the interview requirements",
  },
]

export const ACTION_TYPES = {
  systemChecksCompleted: "SYSTEM_CHECKS_COMPLETED",
  aiServicesNoticeShown: "EXTERNAL_AI_ACKNOWLEDGED",
  externalFlashcardAcknowledge: "EXTERNAL_FLASHCARD_ACKNOWLEDGE",
  externalNotesAcknowledge: "EXTERNAL_NOTES_ACKNOWLEDGED",
  externalVideoSummarizerAcknowledge: "EXTERNAL_VIDEO_SUMMARIZER_ACKNOWLEDGED",
  externalQuestionBankAcknowledge: "EXTERNAL_QUESTION_BANK_ACKNOWLEDGED",
} as const

/**
 * Checks if the interview config is for Swayam external client with specific type
 * @param config - Interview configuration object
 * @param type - Optional type to check for (e.g., "tech_interview", "hr_interview")
 * @returns boolean indicating if the config matches Swayam external criteria
 */
export const isSwayamExternalInterview = (config: any, type?: string): boolean => {
  if (config?.external?.client !== "swayam") {
    return false
  }

  if (type && config?.external?.type !== type) {
    return false
  }

  return true
}
